// extracted by mini-css-extract-plugin
module.exports = {"card":"CardOverlay_card__rQxT9","card-title":"CardOverlay_card-title__1TIyd","card-subtitle":"CardOverlay_card-subtitle__2i7b6","inner":"CardOverlay_inner__vcVPX"};